module.exports = __webpack_public_path__ + "aa503c1f10acbbd8c298b412eb6d7f91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/5-star.svg
// module id = 977
// module chunks = 0